export class User {
    id;
    username;
    emailAddress;
    constructor(id, username, emailAddress) {
        this.id = id;
        this.username = username;
        this.emailAddress = emailAddress;
    }
    static fromModel(id, username) {
        return new User(id, username);
    }
    static fromJson(data) {
        if (data == null ||
            typeof data !== "object" ||
            !("id" in data) ||
            !("username" in data)) {
            throw new Error("Invalid user data");
        }
        return new User(data.id, data.username);
    }
    toJSON() {
        return { id: String(this.id), username: this.username };
    }
}
//# sourceMappingURL=user.js.map